"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _index = require("./index");
var _Tooltip = _interopRequireDefault(require("../tooltip/Tooltip"));
var _Checkbox = _interopRequireDefault(require("../checkbox/Checkbox"));
var _loader = require("../loader");
var _misc = require("../misc");
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _Paragraph = _interopRequireDefault(require("../misc/Paragraph"));
var _DataTable = _interopRequireDefault(require("./DataTable.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var BasicDataTable = function BasicDataTable(props) {
  var checkbox = props.checkbox,
    hideHeader = props.hideHeader,
    orderByField = props.orderByField,
    prefixId = props.prefixId,
    headLabels = props.headLabels,
    genericLabels = props.genericLabels,
    data = props.data,
    isLoading = props.isLoading,
    cellProps = props.cellProps,
    sort = props.sort,
    menuList = props.menuList,
    noResultsMessage = props.noResultsMessage,
    description = props.description,
    striped = props.striped,
    hoverable = props.hoverable;
  var loaderLabel = genericLabels.loaderLabel;
  var tableKeys = Object.keys(headLabels);
  var tableLabels = R.values(headLabels);
  return /*#__PURE__*/_react["default"].createElement(_DataTable["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "data-table-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-container"
  }, isLoading ? /*#__PURE__*/_react["default"].createElement(_loader.PageLoader, {
    pastDelay: true,
    message: loaderLabel
  }) : /*#__PURE__*/_react["default"].createElement(_index.Table, {
    borderless: true,
    striped: striped,
    hoverable: hoverable
  }, !hideHeader && /*#__PURE__*/_react["default"].createElement(_index.TableHead, null, /*#__PURE__*/_react["default"].createElement(_index.TableRow, null, checkbox && /*#__PURE__*/_react["default"].createElement(_index.TableHeadCell, cellProps ? cellProps.checkbox : {}, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    onChange: function onChange(event, value) {
      props.checkbox.selectAll(value);
    },
    checked: R.all(function (item) {
      return props.checkbox.selectedItems.indexOf(item.id) >= 0;
    })(data) && R.length(data) > 0,
    disabled: R.all(function (item) {
      return item.isEnabled;
    })(data)
  })), tableLabels.map(function (label, index) {
    var extraProps = cellProps ? cellProps[tableKeys[index]] : null;
    return /*#__PURE__*/_react["default"].createElement(_index.TableHeadCell, _extends({
      sortable: sort !== null,
      accessor: label,
      clickAction: function clickAction() {
        return orderByField(tableKeys[index]);
      },
      id: "".concat(prefixId, "Column").concat(label),
      key: label,
      sortDirection: sort && (sort.by === tableKeys[index] ? sort.direction : 'default')
    }, extraProps), label);
  }), menuList && /*#__PURE__*/_react["default"].createElement(_index.TableHeadCell, {
    key: "menuOptions"
  }))), /*#__PURE__*/_react["default"].createElement(_index.TableBody, null, data.map(function (dataItem, index) {
    return /*#__PURE__*/_react["default"].createElement(_index.TableRow, {
      key: dataItem.id
    }, checkbox && /*#__PURE__*/_react["default"].createElement(_index.TableCell, _extends({
      key: "".concat(dataItem.id, "Checkbox")
    }, cellProps ? cellProps.checkbox : {}), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      id: "".concat(dataItem.id),
      onChange: function onChange() {
        props.checkbox.onChange(dataItem.id);
      },
      checked: R.indexOf(dataItem.id, props.checkbox.selectedItems) > -1,
      disabled: dataItem.isEnabled
    })), tableKeys.map(function (key, keyIdx) {
      var extraProps = cellProps ? cellProps[tableKeys[keyIdx]] : null;
      return /*#__PURE__*/_react["default"].createElement(_index.TableCell, _extends({
        key: "".concat(dataItem.id).concat(tableLabels[keyIdx]),
        id: "".concat(prefixId).concat(index).concat(tableLabels[keyIdx])
      }, extraProps), description && description.destination === tableKeys[keyIdx] && dataItem.description.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        "data-tip": dataItem[description.source].slice(0, 128)
      }, dataItem[tableKeys[keyIdx]]), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        id: "".concat(prefixId).concat(index).concat(description.destination, "Tooltip")
      })) : dataItem[tableKeys[keyIdx]]);
    }), menuList && /*#__PURE__*/_react["default"].createElement(_index.TableCell, {
      id: "".concat(prefixId).concat(index, "More"),
      key: "".concat(dataItem.id, "More"),
      align: "right"
    }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
      id: "".concat(prefixId).concat(index, "MoreIcon"),
      menuItems: dataItem.menuTransform ? dataItem.menuTransform(menuList) : menuList,
      itemId: dataItem.id,
      isActionDisabled: dataItem.isActionDisabled,
      itemsProps: dataItem.menuListProps
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "ion-android-more-vertical",
      size: 18
    }))));
  }))), !isLoading && data.length === 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "no-results-message"
  }, /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], null, noResultsMessage))))));
};
BasicDataTable.defaultProps = {
  hoverable: true,
  checkbox: null,
  striped: true,
  hideHeader: false,
  orderByField: null,
  isLoading: false,
  sort: null,
  cellProps: null,
  menuList: null,
  noResultsMessage: '',
  description: null,
  genericLabels: {}
};
BasicDataTable.propTypes = {
  hoverable: _propTypes["default"].bool,
  checkbox: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    selectedItems: _propTypes["default"].oneOf([_propTypes["default"].array]).isRequired,
    selectAll: _propTypes["default"].func
  }),
  striped: _propTypes["default"].bool,
  orderByField: _propTypes["default"].func,
  prefixId: _propTypes["default"].string.isRequired,
  headLabels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  hideHeader: _propTypes["default"].bool,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    description: _propTypes["default"].string,
    menuListProps: _propTypes["default"].shape({})
  })).isRequired,
  isLoading: _propTypes["default"].bool,
  cellProps: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool]))),
  sort: _propTypes["default"].shape({
    by: _propTypes["default"].string,
    direction: _propTypes["default"].string
  }),
  menuList: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  noResultsMessage: _propTypes["default"].string,
  description: _propTypes["default"].shape({
    destination: _propTypes["default"].string.isRequired,
    source: _propTypes["default"].string.isRequired
  }),
  genericLabels: _propTypes["default"].objectOf(_propTypes["default"].string)
};
var _default = exports["default"] = BasicDataTable;